import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { YoutubePlayerComponent } from './youtube-player.component';
import { YoutubePlayerService } from './services/youtube-player.service';
import { ModuleWithProviders } from '@angular/compiler/src/core';
export class YouTubePlayerModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        YoutubePlayerComponent
    ],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
    providers: [YoutubePlayerService],
    exports: [
        YoutubePlayerComponent
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function YouTubePlayerModule_tsickle_Closure_declarations() {
/** @type {?} */
YouTubePlayerModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YouTubePlayerModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
